import { render, staticRenderFns } from "./info-panel.vue?vue&type=template&id=6d6b11da"
import script from "./info-panel.vue?vue&type=script&lang=js"
export * from "./info-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports